import Link from 'next/link';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';
import { MenuItem, isExpandableMenuItem, isSimpleMenuItem } from '@/types/menu';

interface NavigationProps {
  items: MenuItem[];
  onOpenSub?: (i: number) => void;
  className?: string;
  selected?: number;
}

const itemClasses =
  'text-[13px] font-bold uppercase tracking-[0.05em] transition-colors';

function isActivePath(pathname: string, href?: string) {
  if (!href || !href.startsWith('/')) return false;
  if (href === '/') return pathname === '/';
  return pathname === href || pathname.startsWith(`${href}/`);
}

function Chevron({ className }: { className?: string }) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      aria-hidden
      className={className}
    >
      <path
        d="M1 1l4 4 4-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Navigation({
  items,
  onOpenSub,
  className,
  selected,
}: NavigationProps) {
  const pathname = usePathname();
  return (
    <nav className={className}>
      {items.map((item, index) => {
        if (isSimpleMenuItem(item))
          return (
            <Link
              key={item.label}
              href={item.href ?? '#'}
              className={clsx(
                itemClasses,
                isActivePath(pathname, item.href)
                  ? 'text-orangecaixa'
                  : 'text-white hover:text-orangecaixa'
              )}
            >
              {item.label}
            </Link>
          );
        else if (isExpandableMenuItem(item))
          return (
            <button
              key={item.label}
              type="button"
              onClick={() => onOpenSub?.(index)}
              className={clsx(
                itemClasses,
                'm-0 flex cursor-pointer items-center gap-[5px] border-none bg-transparent p-0 focus:outline-none',
                selected === index
                  ? 'text-orangecaixa'
                  : 'text-white hover:text-orangecaixa'
              )}
            >
              {item.label}
              <Chevron className="text-orangecaixa" />
            </button>
          );
      })}
    </nav>
  );
}
